import Vue from "vue";
import * as Sentry from "@sentry/vue";
import { clone } from "lodash-es";
export function filterValues(properties) {
  properties = clone(properties);

  const FILTER_VALUES = [
    "anyIdentity",
    "identityHint",
    "payerAddress",
    "payerCity",
    "payerEmail",
    "bankAccountHolderName",
    "bankAccountIban",
    "payerPostalcode",
    "payerVatNumber",
    "payerPhone",
    "payerName",
    "payerCountryId",
    "anyIdentity",
    "email",
    "phone",
    "postalIndex",
    //"countryId",
    //"regionId",
    "iban",
    "businessRegCode",
    "addressCity",
    "addressIndex",
    "addressText",
    "guardianEmail",

    "activeIdentifier",
    "identifier",

    "prizePaymentAccountHolderNotLocalTaxResident",
    "prizePaymentAccountHolderName",
    "prizePaymentAccountHolderIdentitynumber",
    "prizePaymentAccountNumber",
    "registrantNotes",
    "logisticNotes",

    "addressHouse",
    "addressIndex",
    "addressState",
    "addressBox",
    "addressCity",
    "addressText",
    "conactPhone",
    "contactEmail",
    "registryCode",

    "firstName",
    "lastName",
    "billingEmail",

    "billingContact",
    "buyerContact",
    "guardianContact",
    "recipientContact",
    "prixeMoneyPayoutContact"
  ];

  FILTER_VALUES.forEach(key => {
    if (properties[key]) {
      properties[key] = "[FILTERED]";
    }
  });

  return properties;
}

if (process.env.VUE_APP_SENTRY_DSN) {
  //console.log("Setting up Sentry");
  Sentry.init({
    Vue,
    environment: process.env.NODE_ENV,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    release: process.env.VUE_APP_RELEASE_VERSION,
    maxBreadcrumbs: 500,
    // release: process.env.VUE_APP_RELEASE_ID,
    //integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    ignoreErrors: [
      "Failed to fetch",
      "Load failed",
      "Kumottu",
      "avbrutt",
      /Network error: [\w\d-]/,
      "Mistet nettverksforbindelsen.",
      "Request aborted",
      "ResizeObserver loop completed with undelivered notifications.",
      "videoLoaded is not defined",
      "Uncaught ReferenceError: videoLoaded is not defined",
      /UnhandledRejection: Non-Error promise rejection captured with value: Request timeout [\w\d-]/
    ],
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /webkit-masked-url:/
    ],
    beforeSend(evt) {
      if (evt.tags?.network_error === "timeout") {
        const { breadcrumbs, contexts } = evt;
        const { operationName } = contexts["Error details"];

        const iniatedQueryCrumb = breadcrumbs.find(
          x => x.category == "query" && x.data.operationName === operationName
        );

        if (
          iniatedQueryCrumb &&
          evt.timestamp - iniatedQueryCrumb.timestamp <= 29
        ) {
          // if its not been at least 29 seconds since query was initiated then drop it as its not timeout error.
          // may mean user has left the website, disconnected or aborted network requests
          return null;
        }
      }

      return evt;
    },
    beforeBreadcrumb(breadcrumb, hint) {
      if (hint && hint.event && hint.event.target) {
        // Just in case, remove special characters
        if (hint.event.target.innerText) {
          const text = ` #text ${hint.event.target.innerText.replace(
            /[^a-zA-Z0-9 ]/g,
            ""
          )}`;
          if (!breadcrumb.message) breadcrumb.message = "";
          breadcrumb.message += text.length > 185 ? text.slice(0, 185) : text;
        } else {
          if (!breadcrumb.message) breadcrumb.message = "";
          breadcrumb.message += " #text null";
        }
      }

      if (breadcrumb.category == "fetch") {
        //console.log(breadcrumb, hint);
        const body = JSON.parse(hint.input[1].body);
        if (body.operationName) {
          /*if (IGNORE_BREADCRUMB_OPERATION_NAME.includes(body.operationName)) {
            // Still appeared in breadrumbs, for now just ignore this logic
            // Return null to discard breadcrumb
            return null;
          }*/
          breadcrumb.message = `operationName: ${body.operationName}`;
          breadcrumb.data = {
            operationName: body.operationName,
            variables: filterValues(body.variables),
            statusCode: breadcrumb.data.status_code
          };

          if (hint.data instanceof TypeError || hint.data instanceof Error) {
            breadcrumb.message = `operationName: ${body.operationName} - ${hint.data.message}`;
            breadcrumb.data.errorMessage = hint.data.message;
          }
        }
      }
      return breadcrumb;
    }
  });
}
